/**
 * Index
 */
export const Index = (function () {

  var init =  function () {  
      // Code
  }

  return {
    init: init
  }

}());
